export enum ColorTheme {
    LIGHT = 'light',
    DARK = 'dark',
}
